/* free-guard.js — STRICT LOCAL BLOCK (1 Item Max + $0.00 Total) */
(function () {
  if (window.__FREE_GUARD_SERVER__) return;
  window.__FREE_GUARD_SERVER__ = true;

  // Hide all default checkout buttons immediately
  const style = document.createElement('style');
  style.textContent = `
    #checkout,
    #CartDrawer-Checkout,
    button[name="checkout"],
    button[data-test="checkout-button"],
    a[href^="/checkout"],
    .shopify-payment-button,
    .additional-checkout-buttons,
    .cart__dynamic-checkout-buttons,
    [data-shopify="payment-button"] {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  const ALLOW_WINDOW_MS = 8000;
  const CHECKOUT_BTN_SELECTORS = [
    '#checkout',
    '#CartDrawer-Checkout',
    'button[name="checkout"]',
    'button[data-test="checkout-button"]',
    'a[href^="/checkout"]'
  ].join(',');

  const ACCELERATED_SELECTORS = [
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '.cart__dynamic-checkout-buttons',
    '[data-shopify="payment-button"]'
  ].join(',');

  let lastHasPaid = null;
  let allowUntil = 0;

  const qsa = (s, c = document) => Array.from(c.querySelectorAll(s));
  const isWithinAllow = () => Date.now() < allowUntil;
  const openAllow = () => { allowUntil = Date.now() + ALLOW_WINDOW_MS; };
  const normalizeURL = u => { try { return new URL(u, location.origin).pathname; } catch { return String(u || ''); } };
  const isCheckoutURL = u => { const p = normalizeURL(u); return p === '/checkout' || p.startsWith('/checkout'); };

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!r.ok) throw new Error('cart.js failed');
    return r.json();
  }

  function toggleAccelerated(hide) {
    qsa(ACCELERATED_SELECTORS).forEach(el => {
      if (hide) {
        el.setAttribute('data-free-guard-hidden', '1');
        el.style.display = 'none';
        el.style.pointerEvents = 'none';
      } else if (el.getAttribute('data-free-guard-hidden') === '1') {
        el.style.display = '';
        el.style.pointerEvents = '';
        el.removeAttribute('data-free-guard-hidden');
      }
    });
  }

  function toast(text) {
    let m = document.querySelector('.free-guard__toast');
    if (!m) {
      m = document.createElement('div');
      m.className = 'free-guard__toast';
      m.setAttribute('aria-live', 'polite');
      m.style.cssText =
        'position:fixed;left:50%;top:16px;transform:translateX(-50%);' +
        'background:#111;color:#fff;padding:10px 14px;border-radius:6px;' +
        'z-index:999999;font-size:14px;box-shadow:0 2px 8px rgba(0,0,0,.25)';
      document.body.appendChild(m);
      setTimeout(() => { try { m.remove(); } catch { } }, 3500);
    }
    m.textContent = text || 'Cart contains paid items. Enter a valid FREE code to continue.';
    m.style.display = 'block';
  }

  async function refresh() {
    try {
      const c = await getCart();
      const hasPaid = Number(c.total_price || 0) > 0;
      lastHasPaid = hasPaid;
      
      if (hasPaid) {
        allowUntil = 0; // Kill the timer if price is > 0
        toggleAccelerated(true);
        attachUIAll();
      } else {
        toggleAccelerated(false);
      }
      return hasPaid;
    } catch (e) {
      lastHasPaid = true;
      toggleAccelerated(true);
      attachUIAll();
      return true;
    }
  }

  async function mustBlock() {
    const c = await getCart();
    const isActuallyFree = Number(c.total_price || 0) === 0;
    
    // Only allow if in the window AND the cart is still $0
    if (isWithinAllow() && isActuallyFree) return false;
    
    const hasPaid = await refresh();
    return !!hasPaid;
  }

  function buildUI() {
    const w = document.createElement('div');
    w.className = 'free-guard';
    w.innerHTML = `
      <div class="free-guard__group">
        <div class="free-guard__heading">Enter free code to checkout:</div>
        <div class="free-guard__controls">
          <input class="free-guard__input" type="text" data-role="free-code" placeholder="Enter code" aria-label="Free code" />
          <button type="button" class="free-guard__btn" data-role="apply-free-code">Apply &amp; Go to checkout</button>
        </div>
        <p class="free-guard__msg" data-role="msg" style="display:none" aria-live="polite"></p>
      </div>
      <style>
        .free-guard{margin:.75rem 0 0;max-width:420px}
        .free-guard__heading{font-weight:600;margin-bottom:.35rem}
        .free-guard__controls{display:flex;gap:.5rem;align-items:center}
        .free-guard__input{flex:1 1 auto;min-width:140px;padding:.6rem .7rem;border:1px solid #ccc;border-radius:4px}
        .free-guard__btn{padding:.6rem .9rem;border:1px solid #bbb;border-radius:4px;background:#f2f2f2;cursor:pointer}
        .free-guard__btn:hover{filter:brightness(.98)}
        .free-guard__msg{margin:.5rem 0 0;color:#c00}
        .free-guard__dim{opacity:.5;pointer-events:none}
      </style>`;
    return w;
  }

  function attachUI(btn) {
    if (!btn || btn.__freeGuardUi) return;
    btn.__freeGuardUi = true;

    const ui = buildUI();
    (btn.parentNode || document.body).insertBefore(ui, btn);
    if (lastHasPaid) btn.classList.add('free-guard__dim');

    const input = ui.querySelector('[data-role="free-code"]');
    const apply = ui.querySelector('[data-role="apply-free-code"]');
    const msg = ui.querySelector('[data-role="msg"]');

    apply.addEventListener('click', async () => {
      const code = (input.value || '').trim();
      msg.style.display = 'block';
      msg.textContent = 'Verifying...';
      if (!code) { msg.textContent = 'Please enter a code.'; return; }

      apply.disabled = true; apply.style.opacity = '0.6';
      try {
        const cartData = await getCart();
        if (cartData.item_count > 1) {
          msg.textContent = 'Only one item allowed per order.';
          return;
        }

        await fetch(`/discount/${encodeURIComponent(code)}`);
        const updatedCart = await getCart();
        
        if (updatedCart.total_price === 0) {
          msg.style.display = 'none';
          openAllow(); 
          window.location.href = '/checkout?discount=' + encodeURIComponent(code);
        } else {
          msg.textContent = 'That code does not make your cart free.';
        }
      } catch (e) {
        msg.textContent = 'Error. Try again.';
      } finally {
        apply.disabled = false; apply.style.opacity = '';
      }
    });

    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); apply.click(); }
    });
  }

  function attachUIAll() { qsa(CHECKOUT_BTN_SELECTORS).forEach(attachUI); }

  async function gateAnchor(ev, a) {
    const href = a.getAttribute('href');
    if (!href || !isCheckoutURL(href)) return false;
    ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
    if (await mustBlock()) { toast(); attachUIAll(); return true; }
    window.location.href = href;
    return true;
  }

  async function gateForm(ev, form) {
    const action = (form.getAttribute('action') || '').toLowerCase();
    const hasCheckoutInput = form.querySelector('input[name="checkout"],button[name="checkout"]');
    const isCartToCheckout = action.includes('/checkout') || action.includes('/cart') || !!hasCheckoutInput;
    if (!isCartToCheckout) return false;
    ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
    if (await mustBlock()) { toast(); attachUIAll(); return true; }
    HTMLFormElement.prototype.submit.call(form); return true;
  }

  document.addEventListener('click', (ev) => {
    const el = ev.target && ev.target.closest && ev.target.closest('a,button,input,div,span');
    if (!el) return;
    if (el.tagName === 'A' && el.hasAttribute('href')) { gateAnchor(ev, el); return; }
    if (el.matches && el.matches(CHECKOUT_BTN_SELECTORS)) {
      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
      (async () => {
        if (await mustBlock()) { toast(); attachUIAll(); return; }
        const form = el.closest('form');
        if (form) { HTMLFormElement.prototype.submit.call(form); return; }
        window.location.assign('/checkout');
      })();
    }
  }, true);

  document.addEventListener('submit', (ev) => { gateForm(ev, ev.target); }, true);

  const observer = new MutationObserver(() => {
    if (lastHasPaid !== null) toggleAccelerated(!!lastHasPaid);
    if (lastHasPaid) attachUIAll();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => { refresh(); attachUIAll(); });
  const poll = setInterval(() => { refresh(); attachUIAll(); }, 1200);
})();